import type { Branded } from "@@/utilities/branded";
import { z } from "zod";

const roundPercentage = (percentage: Percentage): Percentage => {
    const rounded = Math.round(percentage * 100);
    const output = (rounded / 100) as Percentage;
    return output;
};

/**
 * Percentage in decimal format.
 * E.g. `0.2` (which equals 20%)
 */
type Percentage = Branded<number, "Percentage">;
const percentageZodSchema = z.number() as unknown as z.ZodSchema<Percentage>;
// .min(0, { message: "ett procentvärde kan inte vara lägre än 0" })
// .max(1, {
//     message: "ett procentvärde ska vara mellan 0 och 1",
// }) as unknown as z.ZodSchema<Percentage>;
const percentageToHuman = (percentage: Percentage) => {
    const value = Math.round(percentage * 100);
    return `${value}%`;
};
type PercentageString = string;

const percentageKeyZodSchema = z.string().refine(value => {
    const _value = Number(value.replace("%", ""));
    // console.log("keyzod", _value, (_value / 100) as Percentage);
    const _percentage = percentageZodSchema.parse((_value / 100) as Percentage);
    const _percentageString = percentageToHuman(_percentage);
    return _percentageString === value;
});
type PercentageKey = z.infer<typeof percentageKeyZodSchema>;

function toPercentageKey(percentage: Percentage): PercentageKey;
function toPercentageKey(percentage: string): PercentageKey;
function toPercentageKey(percentage: Percentage | string): PercentageKey {
    const _percentage =
        typeof percentage === "string"
            ? percentage
            : percentageToHuman(percentageZodSchema.parse(percentage));
    return percentageKeyZodSchema.parse(_percentage);
}

const toPercentageFromPercentageKey = (
    percentageKey: PercentageKey,
): Percentage => {
    const _percentage = Number(percentageKey.replace("%", ""));
    return percentageZodSchema.parse((_percentage / 100) as Percentage);
};
const toPercentage = toPercentageFromPercentageKey;

export {
    percentageKeyZodSchema,
    percentageToHuman,
    percentageZodSchema,
    roundPercentage,
    toPercentage,
    toPercentageFromPercentageKey,
    toPercentageKey,
};
export type { Percentage, PercentageKey, PercentageString };
